// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17kNP","largestCol":"styles_largestCol__2lXPu","smallestCol":"styles_smallestCol__3dAiH"};